function _identity(x) {
  return x;
}
module.exports = _identity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_identity.js
// module id = 1373
// module chunks = 0